import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=085e1e5c&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=ts"
export * from "./Personal.vue?vue&type=script&lang=ts"
import style0 from "./Personal.vue?vue&type=style&index=0&id=085e1e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085e1e5c",
  null
  
)

export default component.exports